
import { Layout } from 'frame'
import { Page } from 'frame/components'
import { GraphEndOfLease } from 'features/graph-end-of-lease'
import { GraphKmTracking } from 'features/graph-km-tracking'
import { GraphMaturing } from 'features/graph-maturing'
import { GraphOnOrder } from 'features/graph-on-order'
import { GraphServiceExpiry } from 'features/graph-service-expiry'
import { GraphVehicleEmissions } from 'features/graph-vehicle-emission'
import { GraphFleetComposition } from 'features/graph-fleet-composition'
import {
  useEnabledFeatureToggleList
} from 'features/settings'

import { GraphWofExpiry } from 'features/graph-wof-expiry'
import { GraphVehicleOnExtension } from 'features/graph-vehicle-on-extension'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { GraphFuelExceptions } from 'features/graph-fuel-exception'

const Dashboard = () => {
  const featureToggleList = useEnabledFeatureToggleList()
  const tfp2579FeatureToggle = featureToggleList.includes('TFP2579')
  const tfp2606FeatureToggle = featureToggleList.includes('TFP2606')
  const tfp2609FeatureToggle = featureToggleList.includes('TFP2609')

  return (
    <Layout>
      <Stack padding={3}>
        <Page title="Dashboard">
          <Stack pb={3}>
            <Typography variant="h2" fontWeight={600}>
              Dashboard Overview
            </Typography>
          </Stack>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: '1fr 1fr',
                md: '1fr 1fr 1fr',
              },
              gap: '24px',
            }}>
            <GraphMaturing />
            <GraphOnOrder />
            <GraphWofExpiry />
            <GraphEndOfLease />
            <GraphKmTracking />
            <GraphServiceExpiry />
            {tfp2579FeatureToggle && <GraphVehicleEmissions />}
            {tfp2606FeatureToggle && <GraphFleetComposition />}
            {tfp2609FeatureToggle && <GraphFuelExceptions />}
            <Box sx={{ gridColumn: '1 / -1' }}>
              <GraphVehicleOnExtension />
            </Box>
          </Box>
        </Page>
      </Stack>
    </Layout>
  )
}

export default Dashboard
